// Typed delivery-log endpoint functions. Backed by GET /api/v1/delivery-logs.
//
// CHG-1643 / Wave 1 Tier 1 — port of v1 DeliveryLogs.tsx. Backend handler:
// src/api/app/routers/delivery_logs.py. Org-scoped via X-Org-Context header
// (resolve_org_id); platform-admin without active org sees platform-level
// templates (org_id IS NULL) only — same shape as v1.

import { apiClient } from "./client";

export type DeliveryStatus =
  | "queued"
  | "sent"
  | "failed"
  | "bounced"
  | "skipped"
  | "queued_for_topup";

export interface DeliveryLogEntry {
  id: string;
  organization_id: string | null;
  recipient_email: string;
  template_slug: string;
  subject: string | null;
  status: DeliveryStatus | string;
  error_message: string | null;
  sent_at: string | null;
  created_at: string;
}

interface DeliveryEnvelope {
  data: DeliveryLogEntry[];
  pagination: { page: number; per_page: number; total: number; total_pages: number };
}

export interface ListDeliveryLogsParams {
  page?: number;
  pageSize?: number;
  template_slug?: string;
  status?: DeliveryStatus;
  recipient?: string;
}

export async function listDeliveryLogs(
  params: ListDeliveryLogsParams = {},
): Promise<{ items: DeliveryLogEntry[]; total: number }> {
  const pageSize = params.pageSize ?? 50;
  const r = await apiClient().get<DeliveryEnvelope>("/delivery-logs", {
    params: {
      page: (params.page ?? 0) + 1,
      per_page: pageSize,
      template_slug: params.template_slug || undefined,
      status: params.status || undefined,
      recipient: params.recipient || undefined,
    },
  });
  return { items: r.data.data, total: r.data.pagination.total };
}

export const deliveryLogsApi = { listDeliveryLogs };
